import adminAuditoriaService from '../../services/admin/AdminAuditoriaService'

export const adminAuditoriaModule = {
  namespaced: true,

  state: {
    registros: [],
    pagination: {
      total: 0,
      current_page: 1,
      per_page: 25,
      last_page: 1,
    },
    filtros: {
      modulos: [],
      acoes: [],
      usuarios: [],
    },
    loading: true,
  },

  mutations: {
    SET_REGISTROS(state, payload) {
      state.registros = payload.data || []

      if (payload.total !== undefined) {
        state.pagination = {
          total: payload.total,
          current_page: payload.current_page,
          per_page: payload.per_page,
          last_page: payload.last_page,
        }
      }
    },
    SET_FILTROS(state, payload) {
      state.filtros = {
        modulos: payload?.modulos || [],
        acoes: payload?.acoes || [],
        usuarios: payload?.usuarios || [],
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },

  actions: {
    async fetchRegistros({ commit }, params = {}) {
      commit('SET_LOADING', true)

      try {
        const data = await adminAuditoriaService.getRegistros(params)
        commit('SET_REGISTROS', data)
        return data
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchFiltros({ commit }) {
      const data = await adminAuditoriaService.getFiltros()
      commit('SET_FILTROS', data)
      return data
    },
  },

  getters: {
    registros: (state) => state.registros,
    pagination: (state) => state.pagination,
    filtros: (state) => state.filtros,
    loading: (state) => state.loading,
  },
}
